// extracted by mini-css-extract-plugin
module.exports = {"list":"DropDown_list__3Jn8r","active":"DropDown_active__3r_O8","trigger":"DropDown_trigger__2LqQ5"};